module.exports = __webpack_public_path__ + "img/lookbook_11_center_back.c685617e.png";